import { Action } from 'redux';
import { ConsumerState, ConsumerUnloadState } from '../../states/ConsumerState';
import { Consumer } from '../../../models/Entities/Consumer';

export default function ConsumerBaseReducer(
  state: ConsumerState | undefined,
  action: Action
): ConsumerState {
  const currentState = state ?? ConsumerUnloadState;
  const a: any = action;

  switch (a.type) {
    // GET ALL
    case 'CONSUMER_GET_ALL_REQUEST_ACTION':
      return {
        ...currentState,
        isLoadingAll: true,
        successLoadingAll: false,
        failOnLoadingAll: false,
        error: undefined
      };
    case 'CONSUMER_GET_ALL_RECEIVE_ACTION':
      return {
        ...currentState,
        isLoadingAll: false,
        successLoadingAll: true,
        failOnLoadingAll: false,
        error: undefined,
        list: (currentState.list?.length ?? 0) > 0
          ? (a.Consumers || []).map((incomingConsumer: Consumer) => {
              const existing = (currentState.list || []).find((c: Consumer) => c.id === incomingConsumer.id);
              return existing ? { ...existing, ...incomingConsumer } : incomingConsumer;
            })
          : a.Consumers
      };
    case 'CONSUMER_GET_ALL_FAIL_ACTION':
      return {
        ...currentState,
        isLoadingAll: false,
        successLoadingAll: false,
        failOnLoadingAll: true,
        error: a.error
      };

    // UPDATE ALL
    case 'CONSUMER_UPDATE_ALL_REQUEST_ACTION':
      return {
        ...currentState,
        isUpdatingAll: true,
        isUpdatingAllSuccess: false,
        FailUpdatingAll: false,
        error: undefined
      };
    case 'CONSUMER_UPDATE_ALL_RECEIVE_ACTION':
      return {
        ...currentState,
        isUpdatingAll: false,
        isUpdatingAllSuccess: true,
        FailUpdatingAll: false,
        error: undefined,
        list: (currentState.list?.length ?? 0) > 0
          ? (a.Consumers || []).map((incomingConsumer: Consumer) => {
              const existing = (currentState.list || []).find((c: Consumer) => c.id === incomingConsumer.id);
              return existing ? { ...existing, ...incomingConsumer } : incomingConsumer;
            })
          : a.Consumers
      };
    case 'CONSUMER_UPDATE_ALL_FAIL_ACTION':
      return {
        ...currentState,
        isUpdatingAll: false,
        isUpdatingAllSuccess: false,
        FailUpdatingAll: true,
        error: a.error
      };

    // GET BY ID
    case 'CONSUMER_GET_BY_ID_REQUEST_ACTION':
      return {
        ...currentState,
        isLoadingOne: true,
        successLoadingOne: false,
        failOnLoadingOne: false,
        error: undefined
      };
    case 'CONSUMER_GET_BY_ID_RECEIVE_ACTION': {
      const CurrentConsumer = (currentState.list || []).find((item: Consumer) => item.id === a.Consumer.id);
      const updatedConsumer = CurrentConsumer ? { ...CurrentConsumer, ...a.Consumer } : a.Consumer;
      return {
        ...currentState,
        isLoadingOne: false,
        successLoadingOne: true,
        failOnLoadingOne: false,
        error: undefined,
        list: CurrentConsumer
          ? [...(currentState.list || []).filter((item: Consumer) => item.id !== a.Consumer.id), updatedConsumer]
          : [...(currentState.list || []), a.Consumer]
      };
    }
    case 'CONSUMER_GET_BY_ID_FAIL_ACTION':
      return {
        ...currentState,
        isLoadingOne: false,
        successLoadingOne: false,
        failOnLoadingOne: true,
        error: a.error
      };

    // ADD
    case 'CONSUMER_ADD_REQUEST_ACTION':
      return {
        ...currentState,
        isAdding: true,
        isAddingSuccess: undefined,
        failOnAdding: false,
        error: undefined
      };
    case 'CONSUMER_ADD_RECEIVE_ACTION':
      return {
        ...currentState,
        isAdding: false,
        isAddingSuccess: true,
        failOnAdding: false,
        error: undefined,
        list: [...(currentState.list || []), a.Consumer]
      };
    case 'CONSUMER_ADD_FAIL_ACTION':
      return {
        ...currentState,
        isAdding: false,
        isAddingSuccess: false,
        failOnAdding: true,
        error: a.error
      };

    // UPDATE
    case 'CONSUMER_UPDATE_REQUEST_ACTION':
      return {
        ...currentState,
        isSaving: true,
        isSavingSuccess: undefined,
        failOnSaving: false,
        error: undefined
      };
    case 'CONSUMER_UPDATE_RECEIVE_ACTION':
      return {
        ...currentState,
        isSaving: false,
        isSavingSuccess: true,
        failOnSaving: false,
        error: undefined,
        list: [...(currentState.list || []).filter((item: Consumer) => item.id !== a.Consumer.id), a.Consumer]
      };
    case 'CONSUMER_UPDATE_FAIL_ACTION':
      return {
        ...currentState,
        isSaving: false,
        isSavingSuccess: false,
        failOnSaving: true,
        error: a.error
      };

    // DELETE
    case 'CONSUMER_DELETE_REQUEST_ACTION':
      return {
        ...currentState,
        isDeleting: true,
        isDeletingSuccess: undefined,
        failOnDeleting: false,
        error: undefined
      };
    case 'CONSUMER_DELETE_RECEIVE_ACTION':
      return {
        ...currentState,
        isDeleting: false,
        isDeletingSuccess: true,
        failOnDeleting: false,
        error: undefined,
        list: (currentState.list || []).filter((item: Consumer) => item.id !== a.ConsumerId)
      };
    case 'CONSUMER_DELETE_FAIL_ACTION':
      return {
        ...currentState,
        isDeleting: false,
        isDeletingSuccess: false,
        failOnDeleting: true,
        error: a.error
      };

    default:
      return currentState;
  }
}
